import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import appActions from '../../actions/actions';
import discontinuedBrandActions from '../../actions/discontinuedBrand';
import DiscontinuedBrand from './DiscontinuedBrand';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', ''),
        emailAddress: get(state, 'app.userEmailAddress', ''),
        integratedBrandsPrimarySiteList: get(state, 'app.integratedBrandsPrimarySiteList', []),
        translations: state.app.translations,
        serviceError: get(state, 'discontinuedBrand.serviceError', ''),
        userType: get(state, 'app.userType', ''),
        isConsolidationRequired: get(state, 'app.isConsolidationRequired', true)
    };
}
function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        discontinuedBrandActions: bindActionCreators(discontinuedBrandActions, dispatch),
        dispatch
    };
}
@connect(mapStateToProps, mapDispatchToProps)
export default class DiscontinuedBrandContainer extends React.Component {
    constructor(props) {
        super(props);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.props.appActions.enableLoadOverLay(false);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Discontinued Brand Page');
    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Discontinued Brand Continue'
        }, {});
        this.props.appActions.changeAppState('BRAND_DETERMINATION');
    }

    handleAlertDismiss() {
        this.props.discontinuedBrandActions.discontinuedBrandDismissAlertBox();
    }

    render() {
        return (
            <DiscontinuedBrand publicUuid={this.props.publicUuid}
                translations={this.props.translations}
                handleFormSubmit={this.handleFormSubmit}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                setIsDiscontinuedBrandAction={this.setIsDiscontinuedBrandAction}
                integratedBrandsPrimarySiteList={this.props.integratedBrandsPrimarySiteList}
                emailAddress={this.props.emailAddress}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
            />
        );
    }
}

DiscontinuedBrandContainer.propTypes = {
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};
DiscontinuedBrandContainer.defaultProps = {
    publicUuid: '-1'
};
